import { Typography } from "@suraasa/placebo-ui"
import GradientImage from "assets/Cpat/cpat_contact_us_gradient.webp"
import PageContainer from "components/PageContainer"
import { ArrowRight, Mail } from "iconoir-react"
import { Link } from "react-router-dom"

const generateEmailForCpatEnquiry = () => {
  const subject = encodeURIComponent("CPAT Assistance Required")
  const body = encodeURIComponent(`
Hello Suraasa Team,
I need assistance regarding the CPAT Assessment.
`)
  return `mailto:care@suraasa.com?body=${body}&subject=${subject}`
}

const CpatContactUs = () => {
  return (
    <div
      className="relative mt-8"
      style={{
        background:
          "linear-gradient(180deg, #0F1650 0%, #131527 47.85%, #14151B 100%)",
      }}
    >
      <img src={GradientImage} alt="" className="absolute right-0" />
      <PageContainer>
        <div className="flex flex-wrap justify-between gap-5 pb-[108px] pt-[78px]">
          <div className="flex flex-col">
            <Typography variant="title2" className="mb-0.5 text-white">
              Contact Us
            </Typography>
            <Typography variant="subtitle1" className="text-onSurface-400">
              Need help? We’re here for you.
            </Typography>
          </div>
          <Link to={generateEmailForCpatEnquiry()} className="z-10">
            <button className="rounded-[12px] bg-white p-2.5">
              <div className="flex flex-row gap-12">
                <div className="flex flex-col justify-between">
                  <div className="flex flex-row items-center gap-0.25">
                    <Mail className="size-1.5" color="onSurface-500" />
                    <Typography
                      variant={"smallBody"}
                      className="text-onSurface-500"
                    >
                      Email
                    </Typography>
                  </div>
                  <Typography variant={"strong"}>care@suraasa.com</Typography>
                </div>
                <div className="rounded-[12px] bg-black p-1.75">
                  <ArrowRight color="white" className="!size-2" />
                </div>
              </div>
            </button>
          </Link>
        </div>
      </PageContainer>
    </div>
  )
}

export default CpatContactUs
